var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Email Sent... We will be with you shortly")]),_c('router-link',{attrs:{"tag":"a","to":"/"}},[_vm._v("Go home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }